import TabList from './TabList';

const initTabList = (element) => {
    return new TabList(element);
};

export {
    TabList,
    initTabList
};
